class Recruit {
  constructor() {
    if ($(".js-jobs-swiper").length > 0) {
      this.event();
    }
  }
  event() {
    let swiper = null;
    const mq = window.matchMedia('(max-width: 767px)');

    const initSwiper = () => {
      if (mq.matches) {
        if (!swiper) {
          swiper = new Swiper(".js-jobs-swiper", {
            centeredSlides: true,
            slidesPerView: 1.25,
            spaceBetween: 16,
            loop: true,
            loopAdditionalSlides: 3,
            speed: 500,
            autoplay: {
              delay: 3000,
              disableOnInteraction: false,
            },
            pagination: {
              el: ".js-jobs-swiper-pagination",
              clickable: true,
            },
            navigation: {
              nextEl: ".js-jobs-swiper-next",
              prevEl: ".js-jobs-swiper-prev",
            },
          });
        }
      } else {
        if (swiper) {
          swiper.destroy(true, true);
          swiper = null;
        }
      }
    };

    initSwiper();
    mq.addEventListener('change', initSwiper);
  }
}
